import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { getToken } from '../../../selectors/base.selectors';
import { BaseActionTypes } from '../../../actions/base.actions';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { State } from '../../../index';
import { HttpService } from '../../../../services/http.service';
import { GraphQlEffectService } from '../../../../services/graph-ql-effect.service';
import { MembershipActions } from '../../../actions/mdqx/doctor/membership.actions';
import { MembershipEntity } from '../../../../entities/mdqx/doctor/membership.entity';
import { environment } from '../../../../../../environments/environment';
import { concatMap } from 'rxjs/internal/operators/concatMap';
import { GetDoctorsRequest } from '../../../actions/mdqx/doctor/doctor.actions';


enum ErrorCodes {
    Load = 'Mitgliedschaft Abrufen fehlgeschlagen',
    Modify = 'Mitgliedschaft Bearbeiten fehlgeschlagen',
    Remove = 'Mitgliedschaft Löschen fehlgeschlagen',
    Add = 'Mitgliedschaft Hinzufügen fehlgeschlagen',
}

@Injectable()
export class MembershipEffects {
    errors$ = createEffect(() => this.actions$.pipe(
        ofType(MembershipActions.loadFailure,
            MembershipActions.putFailure,
            MembershipActions.changeFailure,
            MembershipActions.deleteFailure,
            ),
        map((action) => BaseActionTypes.ErrorAction({
            Payload: {
                ToasterMessage: action.ToasterMessage,
                Err: action.Errors,
            }
        }))
    ))

    Get$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MembershipActions.loadRequest),
                // map(() => {
                //     return MembershipActions.loadSuccess({Payload: [
                //             MembershipEntity.fromBackend({id: 1, name: 'q1'}),
                //             MembershipEntity.fromBackend({id: 2, name: 'q2'}),
                //         ]})
                // })
                withLatestFrom(this.store$.select(getToken)),
                switchMap(([{ Payload }, token]) => {
                    const queryString = `query {
                    membership{
                        ${MembershipEntity.GqlFields.join(',')}
                    }
                }`;
                    return this.gatewayHttpService.graphQl({ query: queryString }, { token, retry: true }, '', environment.mdqxGatewayApiUrl).pipe(
                        tap((res) => {
                            this.store$.dispatch(
                                res && res.membership
                                    ?
                                    MembershipActions.loadSuccess({
                                        Payload: res.membership.map((val) => MembershipEntity.fromBackend(val)),
                                    })
                                    : MembershipActions.loadFailure(
                                        { ToasterMessage: ErrorCodes.Load,
                                            Errors: 'wrong response membership'},
                                    ),
                            );
                        }),
                        catchError((err, caught) => {
                            this.store$.dispatch(
                                MembershipActions.loadFailure({
                                    ToasterMessage: ErrorCodes.Load,
                                    Errors: err,
                                }),
                            );
                            return EMPTY;
                        }),
                    );
                }),
            ),
        { dispatch: false },
    );
 Put$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MembershipActions.changeRequest),
            withLatestFrom(this.store$.select(getToken)),
            concatMap(([{ Payload }, token]) => {
                const queryString = `
                mutation{
                  changeMembership(id: ${Payload.id} name: "${Payload.name}"){
                  ${MembershipEntity.GqlFields.join(',')}
                  }
                }
                `
                return this.gatewayHttpService.graphQl({ query: queryString }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                    map((res) => {
                        if (res?.changeMembership) {
                            return MembershipActions.changeSuccess({Payload: MembershipEntity.fromBackend(res.changeMembership)});
                        } else {
                            return MembershipActions.changeFailure({
                                ToasterMessage: ErrorCodes.Modify,
                                Errors: 'wrong response changeMembership',
                            });
                        }
                    }),
                    catchError((err, caught) => {
                        return of(MembershipActions.changeFailure({
                            ToasterMessage: ErrorCodes.Modify,
                            Errors: err,
                        }));
                    }),
                );
            }),
        ),
    );
    Delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MembershipActions.deleteRequest),
            withLatestFrom(this.store$.select(getToken)),
            concatMap(([{ Payload }, token]) => {
                const queryString = `
                mutation{
                  deleteMembership(id: ${Payload.id})
                }
                `
                return this.gatewayHttpService.graphQl({ query: queryString }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                    concatMap((res) => {
                        if (res?.deleteMembership) {
                            return [MembershipActions.deleteSuccess({Payload: Payload.id}), new GetDoctorsRequest()];
                        } else {
                            return [MembershipActions.deleteFailure({
                                ToasterMessage: ErrorCodes.Remove,
                                Errors: 'wrong response deleteMembership',
                            })];
                        }
                    }),
                    catchError((err, caught) => {
                        return of(MembershipActions.deleteFailure({
                            ToasterMessage: ErrorCodes.Remove,
                            Errors: err,
                        }));
                    }),
                );
            }),
        ),
    );
    constructor(private actions$: Actions, private store$: Store<State>, private gatewayHttpService: HttpService, private graphQlEffectService: GraphQlEffectService) {}
}
